<template>

  <div
    id="map"
    style="height: 500px; width: 100%"
    class="mb-4"
  />

</template>

<script>
import { createMap, drawPoints } from 'maplibre-gl-js-amplify'
import 'maplibre-gl-js-amplify/dist/public/amplify-map.css'

export default {
  components: {
  },
  props: {
    site: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      map: null,
    }
  },
  watch: {
    site: {
      handler() {
        this.createMap()
      },
      deep: true,
    },
  },
  mounted() {
    this.createMap()
  },
  methods: {
    async createMap() {
      if (!this.map) {
        this.map = await createMap({
          container: 'map',
          center: JSON.parse(this.site.AWSLongLat),
          markerCoordinates: JSON.parse(this.site.AWSLongLat),
          zoom: 16,
        })
        this.map.on('load', () => {
          drawPoints('mySourceName', [{
            coordinates: JSON.parse(this.site.AWSLongLat),
            title: 'Golden Gate Bridge',
            address: 'A suspension bridge spanning the Golden Gate',
          }], this.map)
        })
      } else {
        this.map.remove()
        this.map = null
        this.createMap()
      }
    },
  },
}
</script>

<style>

</style>
